import App from 'App';
import React from 'react';
import ReactDOM from 'react-dom';
import 'chart.js/auto';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
// import {store} from "stores/store";
//  React Dark Mode themes
import { ThemeProvider } from '@mui/material/styles';
import themeRTL from 'assets/theme/theme-rtl';

import { MaterialUIControllerProvider } from 'context';
import { PersistGate } from 'redux-persist/integration/react';
import DevScreenSizeOverlay from './components/DevScreenSizeOverlay/DevScreenSizeOverlay';
import { configurStore } from './stores/persist';

const { store, persistor } = configurStore();
import { AuthProvider } from './context/AuthProvider';

import { initializeGlobalFetchPatch } from './utils/routeBasedFetchPatch';
initializeGlobalFetchPatch();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <AuthProvider>
            <MaterialUIControllerProvider>
              <ThemeProvider theme={themeRTL}>
                <Routes>
                  <Route path="/*" element={<App />} />
                </Routes>
                <DevScreenSizeOverlay />
              </ThemeProvider>
            </MaterialUIControllerProvider>
          </AuthProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
